import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=c7bdf7c6&"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts&"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports